module.exports = __webpack_public_path__ + "img/vegetable-cabbage-350x184.ac94e610.jpg";